import * as React from 'react';
import { SVGProps } from 'react';

const AccountMoon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width="500"
    height="500"
    viewBox="0 0 500 500"
    {...props}
  >
    <circle cx="250" cy="250" r="183.38" style={{ fill: '#313071' }} />
    <circle
      cx="250"
      cy="250"
      r="210.3"
      style={{ fill: '#313071', opacity: '.4' }}
    />
    <circle
      cx="250"
      cy="250"
      r="232.37"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <path
      d="m178.29,124.2c.22.58.32,1.21.29,1.83-.22,4.99-7.72,11.57-18.22,15.58-10.5,4.01-20.48,4.1-23.95.52-.44-.45-.78-.98-1.01-1.56-1.94-5.09,6.09-12.89,17.94-17.41,11.85-4.52,23.01-4.05,24.95,1.04Z"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <path
      d="m178.58,126.03c-.22,4.99-7.72,11.57-18.22,15.58-10.5,4.01-20.48,4.1-23.95.52.22-4.99,7.72-11.56,18.22-15.57,10.5-4.01,20.47-4.11,23.95-.53Z"
      style={{ fill: '#16133e' }}
    />
    <path
      d="m99.45,259.37c.6-.16,1.23-.2,1.85-.1,4.94.7,10.76,8.81,13.72,19.65,2.97,10.84,2.08,20.78-1.8,23.9-.48.4-1.04.69-1.65.85-5.26,1.44-12.23-7.29-15.58-19.54-3.35-12.26-1.8-23.32,3.45-24.76Z"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <path
      d="m101.3,259.26c4.94.7,10.76,8.81,13.72,19.65,2.97,10.84,2.08,20.78-1.8,23.9-4.94-.7-10.76-8.8-13.73-19.65-2.97-10.84-2.09-20.78,1.81-23.9Z"
      style={{ fill: '#16133e' }}
    />
    <path
      d="m350.92,365.58c-.43-.45-.77-.98-.98-1.56-1.77-4.69,2.52-13.67,10.59-21.5s17.18-11.85,21.81-9.95c.59.24,1.12.59,1.56,1.04,3.8,3.91-.52,14.24-9.61,23.08-9.08,8.83-19.57,12.78-23.37,8.89Z"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <path
      d="m349.94,363.98c-1.77-4.69,2.52-13.67,10.59-21.5s17.18-11.85,21.81-9.95c1.77,4.69-2.52,13.68-10.59,21.51-8.06,7.83-17.2,11.85-21.81,9.94Z"
      style={{ fill: '#16133e' }}
    />
    <path
      d="m168.64,375.18c4.56-7.29,17.7-10.22,31.6-6.52,13.9,3.7,23.84,12.78,24.18,21.35-4.56,7.29-17.7,10.22-31.6,6.52s-23.83-12.76-24.18-21.35Z"
      style={{ fill: '#16133e' }}
    />
    <path
      d="m370.35,139.36c-.47,1-1.09,1.92-1.83,2.73-5.78,6.37-19.26,6.93-32.28.84-13.02-6.09-21.22-16.79-20.03-25.3.15-1.09.46-2.16.93-3.16,4.16-8.85,19.4-10.44,34.09-3.58,14.69,6.87,23.26,19.62,19.12,28.46Z"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <path
      d="m368.52,142.1c-5.78,6.37-19.26,6.93-32.28.84-13.02-6.09-21.22-16.79-20.03-25.3,5.77-6.37,19.26-6.93,32.28-.84,13.02,6.09,21.21,16.79,20.03,25.3Z"
      style={{ fill: '#16133e' }}
    />
    <ellipse
      cx="236.47"
      cy="98.87"
      rx="5.45"
      ry="2.59"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <ellipse
      cx="245.72"
      cy="93.7"
      rx="5.45"
      ry="2.59"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <ellipse
      cx="133.32"
      cy="187.24"
      rx="5.45"
      ry="2.59"
      transform="translate(-90.21 240.83) rotate(-68.03)"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <ellipse
      cx="279.22"
      cy="387.17"
      rx="5.45"
      ry="2.59"
      transform="translate(-154.38 187.54) rotate(-29.48)"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <ellipse
      cx="383.38"
      cy="260.53"
      rx="5.45"
      ry="2.59"
      transform="translate(-1.66 518.6) rotate(-68.03)"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <ellipse
      cx="351.23"
      cy="195.13"
      rx="2.59"
      ry="5.45"
      transform="translate(-36.92 91.31) rotate(-14.08)"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
    <circle cx="193.41" cy="286.82" r="40.35" style={{ fill: '#16133e' }} />
    <path
      d="m233.76,286.82c0,22.29-18.06,40.36-40.34,40.36-12.6,0-24.47-5.88-32.11-15.89,16.7,14.76,42.19,13.19,56.95-3.51,12.75-14.42,13.53-35.84,1.88-51.16,8.66,7.64,13.63,18.64,13.62,30.2Z"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <circle cx="263.95" cy="210.55" r="12.79" style={{ fill: '#16133e' }} />
    <path
      d="m274.9,217.15c2.26-6.69-1.34-13.95-8.03-16.21-5.67-1.91-11.91.36-15.02,5.48,2.28-6.68,9.55-10.25,16.23-7.97,6.68,2.28,10.25,9.55,7.97,16.23-.29.86-.68,1.69-1.15,2.47Z"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <circle cx="316.78" cy="296.85" r="26.98" style={{ fill: '#16133e' }} />
    <path
      d="m343.76,296.86c-.06,14.9-12.18,26.93-27.08,26.88-14.4-.06-26.22-11.41-26.85-25.8,3.33,14.52,17.8,23.6,32.32,20.27,12.27-2.81,20.96-13.74,20.95-26.32,0-.36,0-.72-.03-1.07.46,1.98.68,4.01.68,6.05Z"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <circle cx="201.51" cy="178.68" r="22.93" style={{ fill: '#16133e' }} />
    <path
      d="m223.26,171.39c-5.9-11.22-19.77-15.53-30.99-9.63-9.95,5.23-14.64,16.9-11.09,27.57-5.86-11.23-1.52-25.09,9.71-30.95,11.23-5.86,25.09-1.52,30.95,9.71.55,1.06,1.02,2.16,1.41,3.3Z"
      style={{ fill: '#313071', opacity: '.3' }}
    />
    <path
      d="m167.35,378.2c.28-1.07.72-2.08,1.31-3.01,4.56-7.29,17.7-10.22,31.6-6.52s23.84,12.78,24.18,21.35c.04,1.1-.08,2.2-.36,3.27-2.51,9.44-17.25,13.71-32.92,9.54-15.67-4.16-26.33-15.18-23.82-24.62Z"
      style={{ fill: '#16133e', opacity: '.5' }}
    />
  </svg>
);

export default AccountMoon;
